import styled from 'styled-components';
import { useConsultPresence } from './ConsultPresenceProvider';

const Badge = styled.small`
  background: ${({ theme }) => theme.colors.gray[100]};
  color: ${({ theme }) => theme.colors.gray[900]};
  font-weight: 500;
  text-transform: none;
  padding: 4px 8px;
  border-radius: 4px;
  margin-left: 8px;
  font-size: 10px;
  white-space: nowrap;
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: default;
  flex-shrink: 0;
`;

interface ConsultPresenceBadgeProps {
  consultCode: number | string;
}

export default function ConsultPresenceBadge({ consultCode }: ConsultPresenceBadgeProps) {
  const { isEnabled, getBadgeText } = useConsultPresence();

  if (!isEnabled) return null;

  const badge = getBadgeText(consultCode);
  if (!badge) return null;

  return (
    <Badge title={badge}>
      👁 {badge}
    </Badge>
  );
}
